export const navLinks = [
  { label: "首页", href: "#home" },
  { label: "今日热榜", href: "#hot" },
  { label: "热门分类", href: "#category" },
  { label: "事件短视频", href: "#video" },
  { label: "深度专题", href: "#topic" },
  { label: "常见问题", href: "#faq" },
];

export const heroTags = [
  "明星塌房",
  "全网热议",
  "现场直击",
  "综艺名场面",
  "社会大瓜",
  "科技新瓜",
];

export const categories = [
  {
    name: "明星八卦",
    count: 1286,
    hot: "热搜第一",
    icon: "ri-star-smile-fill",
    image:
      "https://readdy.ai/api/search-image?query=vibrant%20editorial%20photo%20of%20stage%20spotlight%20and%20microphone%20with%20confetti%2C%20celebrity%20gossip%20theme%2C%20warm%20amber%20and%20orange%20tone%2C%20energetic%20pop%20culture%20aesthetic%2C%20soft%20bokeh%20background&width=420&height=560&seq=cat-star-01&orientation=portrait",
  },
  {
    name: "社会热点",
    count: 986,
    hot: "全网关注",
    icon: "ri-fire-fill",
    image:
      "https://readdy.ai/api/search-image?query=modern%20city%20street%20scene%20with%20breaking%20news%20broadcast%20vibe%2C%20warm%20sunset%20light%2C%20urban%20lifestyle%20hot%20topics%20theme%2C%20orange%20and%20coral%20tone%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%20editorial%20photography&width=420&height=560&seq=cat-social-01&orientation=portrait",
  },
  {
    name: "娱乐综艺",
    count: 1523,
    hot: "名场面",
    icon: "ri-aliens-fill",
    image:
      "https://readdy.ai/api/search-image?query=colorful%20variety%20show%20stage%20with%20neon%20lights%20and%20confetti%2C%20entertainment%20television%20theme%2C%20warm%20golden%20and%20orange%20tones%2C%20playful%20and%20vibrant%2C%20editorial%20photography%20with%20soft%20focus&width=420&height=560&seq=cat-ent-01&orientation=portrait",
  },
  {
    name: "科技奇闻",
    count: 674,
    hot: "新瓜速递",
    icon: "ri-rocket-2-fill",
    image:
      "https://readdy.ai/api/search-image?query=futuristic%20tech%20gadgets%20with%20glowing%20amber%20circuit%20patterns%2C%20technology%20marvel%20theme%2C%20warm%20copper%20and%20orange%20tones%2C%20modern%20minimal%20background%2C%20high%20detail%20product%20photography%2C%20mysterious%20innovative%20atmosphere&width=420&height=560&seq=cat-tech-01&orientation=portrait",
  },
  {
    name: "体育赛场",
    count: 842,
    hot: "高光时刻",
    icon: "ri-run-fill",
    image:
      "https://readdy.ai/api/search-image?query=dynamic%20sports%20arena%20with%20athlete%20silhouette%20leaping%20under%20warm%20stadium%20lights%2C%20sports%20competition%20theme%2C%20amber%20and%20bronze%20tones%2C%20motion%20blur%2C%20energetic%20editorial%20photography&width=420&height=560&seq=cat-sport-01&orientation=portrait",
  },
  {
    name: "民生趣闻",
    count: 731,
    hot: "日常瓜点",
    icon: "ri-cup-fill",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20daily%20life%20street%20market%20scene%20with%20warm%20morning%20light%2C%20everyday%20life%20fun%20moments%20theme%2C%20amber%20and%20cream%20tones%2C%20candid%20lifestyle%20photography%2C%20soft%20and%20heartwarming&width=420&height=560&seq=cat-life-01&orientation=portrait",
  },
];

export const hotList = [
  {
    title: "顶流男星被曝深夜密会神秘女子，工作室紧急回应引发全网争议",
    tag: "明星八卦",
    heat: 98.6,
    trend: "up",
    rank: 1,
    time: "刚刚",
  },
  {
    title: "某地超市惊现天价西瓜，一个卖到三千元，网友直呼吃不起瓜了",
    tag: "社会热点",
    heat: 95.2,
    trend: "up",
    rank: 2,
    time: "5分钟前",
  },
  {
    title: "年度最爆综艺名场面合集：导师当场破防，全场笑到失控",
    tag: "娱乐综艺",
    heat: 91.8,
    trend: "up",
    rank: 3,
    time: "12分钟前",
  },
  {
    title: "国产新机发布会全程高能，价格公布瞬间弹幕刷屏热议",
    tag: "科技奇闻",
    heat: 88.4,
    trend: "down",
    rank: 4,
    time: "20分钟前",
  },
  {
    title: "奥运赛场惊现神级翻盘，最后十秒绝杀引全场沸腾",
    tag: "体育赛场",
    heat: 84.7,
    trend: "up",
    rank: 5,
    time: "35分钟前",
  },
  {
    title: "小区门口大妈吵架一句话走红网络，评论区全是段子手",
    tag: "民生趣闻",
    heat: 80.1,
    trend: "up",
    rank: 6,
    time: "48分钟前",
  },
  {
    title: "娱乐圈新一轮婚变传闻发酵，当事人晒合影强势辟谣",
    tag: "明星八卦",
    heat: 76.9,
    trend: "down",
    rank: 7,
    time: "1小时前",
  },
  {
    title: "全网都在找的爆款美食店突然排队三小时，老板笑称接不住",
    tag: "民生趣闻",
    heat: 73.3,
    trend: "up",
    rank: 8,
    time: "1小时前",
  },
  {
    title: "资深主播爆料行业潜规则，直播切片一夜涨粉百万",
    tag: "娱乐综艺",
    heat: 69.8,
    trend: "down",
    rank: 9,
    time: "2小时前",
  },
  {
    title: "全球科技圈重磅瓜：神秘巨头发布划时代黑科技原型",
    tag: "科技奇闻",
    heat: 65.4,
    trend: "up",
    rank: 10,
    time: "3小时前",
  },
];

export const videos = [
  {
    title: "现场直击：顶流发布会万人空巷，粉丝凌晨蹲守全程记录",
    category: "明星八卦",
    views: "1.2亿",
    duration: "04:36",
    date: "08-18",
    heat: 98,
    tag: "现场",
    image:
      "https://readdy.ai/api/search-image?query=large%20crowd%20at%20celebrity%20press%20conference%20at%20night%2C%20fans%20holding%20light%20sticks%2C%20warm%20amber%20and%20orange%20stage%20lights%2C%20energetic%20event%20scene%2C%20cinematic%20editorial%20photography&width=640&height=360&seq=video-01&orientation=landscape",
  },
  {
    title: "全网热议大瓜：一段监控视频揭露的真相让网友集体沉默",
    category: "社会热点",
    views: "8600万",
    duration: "05:12",
    date: "08-18",
    heat: 95,
    tag: "热议",
    image:
      "https://readdy.ai/api/search-image?query=mysterious%20dark%20urban%20alley%20with%20surveillance%20camera%20and%20moody%20amber%20lighting%2C%20mystery%20truth%20reveal%20theme%2C%20warm%20cinematic%20tone%2C%20high%20contrast%20editorial%20photography&width=640&height=360&seq=video-02&orientation=landscape",
  },
  {
    title: "综艺名场面：导师一句话神预测，全场嘉宾瞬间破防大笑",
    category: "娱乐综艺",
    views: "7200万",
    duration: "03:48",
    date: "08-17",
    heat: 91,
    tag: "名场面",
    image:
      "https://readdy.ai/api/search-image?query=colorful%20tv%20variety%20show%20studio%20with%20judges%20laughing%20and%20stage%20lights%2C%20warm%20golden%20and%20orange%20tones%2C%20playful%20atmosphere%2C%20high%20energy%2C%20editorial%20television%20photography&width=640&height=360&seq=video-03&orientation=landscape",
  },
  {
    title: "科技新瓜：全新概念机现场演示，黑科技功能让全场惊呼",
    category: "科技奇闻",
    views: "6400万",
    duration: "06:20",
    date: "08-17",
    heat: 87,
    tag: "新机",
    image:
      "https://readdy.ai/api/search-image?query=futuristic%20smartphone%20launch%20on%20stage%20with%20glowing%20copper%20lights%2C%20tech%20product%20reveal%20theme%2C%20warm%20amber%20tones%2C%20modern%20minimal%20background%2C%20high%20detail%20product%20photography&width=640&height=360&seq=video-04&orientation=landscape",
  },
  {
    title: "体育高光：最后十秒神级绝杀，解说激动到破音喊出神之一手",
    category: "体育赛场",
    views: "5800万",
    duration: "02:55",
    date: "08-16",
    heat: 84,
    tag: "绝杀",
    image:
      "https://readdy.ai/api/search-image?query=athlete%20scoring%20winning%20shot%20in%20stadium%20under%20warm%20bronze%20floodlights%2C%20sports%20clutch%20moment%20theme%2C%20amber%20tones%2C%20dynamic%20motion%2C%20exciting%20editorial%20photography&width=640&height=360&seq=video-05&orientation=landscape",
  },
  {
    title: "街采爆火：路人一句话神吐槽全网共鸣，播放量一夜破亿",
    category: "民生趣闻",
    views: "1.05亿",
    duration: "03:20",
    date: "08-16",
    heat: 81,
    tag: "街采",
    image:
      "https://readdy.ai/api/search-image?query=lively%20street%20interview%20scene%20with%20smiling%20pedestrians%20in%20warm%20sunlight%2C%20everyday%20life%20theme%2C%20amber%20and%20cream%20tones%2C%20candid%20lifestyle%20photography%2C%20bright%20and%20fun&width=640&height=360&seq=video-06&orientation=landscape",
  },
  {
    title: "圈内大瓜：两位昔日搭档互撕细节曝光，旧账全被翻出",
    category: "明星八卦",
    views: "4900万",
    duration: "07:15",
    date: "08-15",
    heat: 78,
    tag: "互撕",
    image:
      "https://readdy.ai/api/search-image?query=two%20silhouettes%20in%20tension%20across%20a%20table%2C%20celebrity%20feud%20rumor%20theme%2C%20dramatic%20warm%20amber%20and%20coral%20lighting%2C%20cinematic%20moody%20editorial%20photography&width=640&height=360&seq=video-07&orientation=landscape",
  },
  {
    title: "暖心瞬间：路人合力救下被困小猫，网友看哭直呼人间值得",
    category: "民生趣闻",
    views: "8700万",
    duration: "02:40",
    date: "08-15",
    heat: 75,
    tag: "暖心",
    image:
      "https://readdy.ai/api/search-image?query=people%20rescuing%20a%20small%20cat%20on%20a%20sunny%20street%2C%20heartwarming%20rescue%20theme%2C%20warm%20golden%20hour%20light%2C%20soft%20cream%20and%20amber%20tones%2C%20touching%20candid%20photography&width=640&height=360&seq=video-08&orientation=landscape",
  },
];

export const topics = [
  {
    title: "从'塌房'到'翻红'：这些年我们追过的顶流风云录",
    excerpt: "回顾近五年的顶流起落，看看流量时代的造星逻辑与饭圈文化如何重塑娱乐圈生态。",
    readTime: "8分钟",
    date: "2026.08.15",
    tag: "深度观察",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20collage%20of%20pop%20culture%20fame%20and%20spotlights%20with%20rise%20and%20fall%20narrative%2C%20warm%20amber%20and%20coral%20tones%2C%20artistic%20editorial%20visual%2C%20rich%20texture&width=800&height=450&seq=topic-01&orientation=landscape",
  },
  {
    title: "短视频时代，我们为什么越来越爱'围观'？",
    excerpt: "从吃瓜心理到流量算法，拆解全民围观现象背后的传播学与社会学逻辑。",
    readTime: "6分钟",
    date: "2026.08.12",
    tag: "热点透视",
    image:
      "https://readdy.ai/api/search-image?query=many%20phones%20watching%20trending%20short%20videos%20together%2C%20social%20media%20spectatorship%20theme%2C%20warm%20orange%20ambient%20lighting%2C%20modern%20concept%20editorial%20photography&width=800&height=450&seq=topic-02&orientation=landscape",
  },
  {
    title: "一场发布会全网刷屏背后：科技营销的流量密码",
    excerpt: "拆解爆款发布会如何制造话题、放大传播，品牌又如何接住这波泼天流量。",
    readTime: "7分钟",
    date: "2026.08.08",
    tag: "行业观察",
    image:
      "https://readdy.ai/api/search-image?query=futuristic%20tech%20launch%20stage%20with%20glowing%20amber%20lights%20and%20crowd%2C%20marketing%20strategy%20theme%2C%20warm%20copper%20tones%2C%20cinematic%20high%20detail%20editorial%20photography&width=800&height=450&seq=topic-03&orientation=landscape",
  },
  {
    title: "绝杀与逆转：那些让全网沸腾的体育名场面",
    excerpt: "盘点体育赛场上令人肾上腺素飙升的经典时刻，见证竞技体育最动人的瞬间。",
    readTime: "5分钟",
    date: "2026.08.03",
    tag: "赛场盘点",
    image:
      "https://readdy.ai/api/search-image?query=epic%20sports%20arena%20celebration%20with%20confetti%20and%20warm%20bronze%20floodlights%2C%20game%20winning%20moment%20theme%2C%20amber%20tones%2C%20energetic%20dynamic%20editorial%20photography&width=800&height=450&seq=topic-04&orientation=landscape",
  },
];

export const testimonials = [
  {
    name: "阿瓜本瓜",
    role: "资深吃瓜群众",
    text: "每天起床第一件事就是打开吃瓜视频网刷热榜，比追剧还上瘾，最新瓜点一个都不漏，太省心了。",
    rating: 5,
    color: "bg-primary-500",
  },
  {
    name: "小葵追热点",
    role: "自媒体运营",
    text: "作为内容从业者，这里分类清楚、更新快，视频素材质量高，帮我省了大量找选题的时间。",
    rating: 5,
    color: "bg-accent-500",
  },
  {
    name: "瓜田守望者",
    role: "晚八点忠实用户",
    text: "页面干净不花哨，热点排行一清二楚，晚上回家翻一翻就知道今天全网都在聊什么，必须安利。",
    rating: 4,
    color: "bg-secondary-500",
  },
  {
    name: "路过看戏人",
    role: "路人吃瓜",
    text: "不灌水不标题党，专题写得很走心，能让我从热闹里看懂背后的门道，这个网站有点东西。",
    rating: 5,
    color: "bg-primary-500",
  },
  {
    name: "八八大队长",
    role: "八卦爱好者",
    text: "分类分类再分类，想看啥点啥，视频加载也快，手机上看体验很舒服，强烈推荐给身边朋友。",
    rating: 5,
    color: "bg-accent-500",
  },
  {
    name: "热心摊主",
    role: "评论区常客",
    text: "评论区氛围特别好，大家都在理性吃瓜，网站对节奏的把握让人舒服，不会为了流量故意挑事。",
    rating: 4,
    color: "bg-secondary-500",
  },
];

export const faqs = [
  {
    question: "吃瓜视频网的内容来自哪里？",
    answer:
      "我们聚合整理全网公开的热点事件短视频与话题内容，并进行分类、排序和标签化，帮助用户更高效地跟进热门瓜点与焦点事件。所有内容均注明来源倾向，尊重原创作者权益。",
  },
  {
    question: "网站多久更新一次热榜？",
    answer:
      "今日热榜会结合全网热度指数实时刷新，通常每隔数分钟就会根据讨论量、播放量等指标重新排序，确保你看到的是当下最热的瓜点与焦点视频。",
  },
  {
    question: "如何快速找到我想看的热点？",
    answer:
      "你可以使用顶部搜索框输入关键词，也可以通过热门分类入口（如明星八卦、社会热点、娱乐综艺等）按主题浏览，或在热榜区按热度排序查看最受关注的视频。",
  },
  {
    question: "视频可以下载或转发吗？",
    answer:
      "网站提供站内分享与收藏功能，方便你转发给好友。请遵守原创者版权约定，勿将内容用于商业用途或二次恶意剪辑传播。",
  },
  {
    question: "看到不实或侵权的信息怎么办？",
    answer:
      "我们非常重视内容质量与版权保护。如发现存在不实信息或涉嫌侵权的内容，可通过页面底部联系方式告知我们，核实后会在第一时间处理并反馈结果。",
  },
  {
    question: "如何订阅最新热点推送？",
    answer:
      "在页面底部联系订阅区填写常用邮箱即可订阅热点通知，我们会在每日热榜更新、重大焦点事件发生时，通过邮件把最新动态第一时间推送到你手中。",
  },
];

export const contactInfo = {
  email: "hello@guagua.example.com",
  wechat: "guagua-video",
  slogan: "瓜田瓜王，一网打尽，天天有瓜，顿顿不落",
};